
export const deleteCookiesForm = () =>{
    localStorage.setItem('firstName','');
    localStorage.setItem('lastName','');
    localStorage.setItem('phoneNumber','');
    localStorage.setItem('email','');
    localStorage.setItem('message','');
}